import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import FormInput from '@/components/form/formInput'
import FormTextarea from '@/components/form/formTextarea'
import InfoToolTip from '@/components/infoTooltip'

import { makeInputUppercaseAndRemoveNonAlphanumeric } from '@/utils/form'

// eslint-disable-next-line react-refresh/only-export-components
export const basicInfoSchema = z.object({
    name: z.string(),
    code: z
        .string()
        .min(4, {
            message: 'Code must be at least 4 characters.',
        })
        .max(8, {
            message: 'Code must be at most 8 characters.',
        }),
    description: z.string().optional(),
})
type BasicInfoSchemaType = z.infer<typeof basicInfoSchema>

interface Props {
    form: UseFormReturn<BasicInfoSchemaType>
}

export default function CreateMarketBasicInfoForm({ form }: Props) {
    return (
        <div className="space-y-4">
            <FormInput control={form.control} name="name" placeholder="Example: Staging NZX Market" label="Name" />
            <FormInput
                control={form.control}
                name="code"
                placeholder="Example: SNZX"
                label={
                    <>
                        Code
                        <InfoToolTip className="ml-2">This is the short code of the market</InfoToolTip>
                    </>
                }
                onInput={makeInputUppercaseAndRemoveNonAlphanumeric}
            />
            <FormTextarea control={form.control} name="description" label="Optional Description" />
        </div>
    )
}
